/**
 * Angular imports.
 */
import { Injectable, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Service imports.
 */
import { OnboardingService } from '../dataservices/onboarding/onboarding.service';
import { DataStorageService } from '../dataservices/data-storage.service';

/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';

/**
 * Pdf imports.
 */
import * as pdfjsLib from 'pdfjs-dist';
// Use a more browser-friendly approach
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.mjs';

/**
 * FileUpload Service
 */
@Injectable({
  providedIn: 'root'
})
export class FileUploadService implements OnDestroy {
  public uploadcounter = 0;
  public uploadfilearray = [];
  public total_files = 0;
  public current_uploading_file = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feed_post_uploading_file = new Subject<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fileUploadProcess = new Subject<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fileUploadaing_failed = new Subject<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public new_feed_post_added = new Subject<any>();
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();


  /**
   * Necessary instances.
   */
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private dss: DataStorageService,
    private onboardingService: OnboardingService) {
  }

  /**
   * init Upload
   */
  initUpload(obj, curr_file, total_files, product_type = 1): void {
    {
      this.dss.posting_data.screen1.media = [];
    }
    this.current_uploading_file = curr_file;
    this.total_files = total_files;
    this.uploadcounter = 0;
    this.uploadfilearray = [];
    const file = obj;
    const file_type = file.type;
    const blob = file;

    let BYTES_PER_CHUNK = 1000024; // **1MB chunk sizes.
    const SIZE = blob.size;
    if (SIZE > 1000024) {
      BYTES_PER_CHUNK = 1000024;
    } else if (SIZE > 100024) {
      BYTES_PER_CHUNK = 100024;
    } else if (SIZE > 10024) {
      BYTES_PER_CHUNK = 10024;
    } else {
      BYTES_PER_CHUNK = 1024;
    }


    const remaining_bites = SIZE % BYTES_PER_CHUNK;
    let start = 0;
    let end = BYTES_PER_CHUNK;
    const d = new Date();
    const n = d.getTime();
    let fileName;

    const count_x = Math.floor(SIZE / BYTES_PER_CHUNK);
    let x = 0;
    while (x < count_x) {
      const chunk = blob.slice(start, end);
      this.uploadfilearray[this.uploadcounter] = chunk;
      this.uploadcounter = this.uploadcounter + 1;
      start = end;
      end = start + BYTES_PER_CHUNK;
      x++;
    }
    if (remaining_bites > 0) {
      const chunk = blob.slice(start, end);
      this.uploadfilearray[this.uploadcounter] = chunk;
      this.uploadcounter = this.uploadcounter + 1;
      start = end;
      end = remaining_bites;
    }
    const num_chunks = this.uploadcounter; // total number of chunks
    this.uploadcounter = 0;
    // eslint-disable-next-line prefer-const
    fileName = n + file.name;

    this.uploadFile(this.uploadfilearray[this.uploadcounter], fileName, num_chunks, this.uploadcounter + 1, file_type, product_type, obj);
  }

  /**
   * upload File
   */
  uploadFile(blobFile, filename, num_chunks, num, file_type, product_type, obj): void {
    if (this.uploadfilearray.length > this.uploadcounter) {
      this.subscriptions.add(this.onboardingService.newUploadInChunk(blobFile, filename, num_chunks, num, file_type, product_type).subscribe(data => {
        // const videoUploadRes = data;
        this.uploadcounter = this.uploadcounter + 1;
        if (this.uploadfilearray.length > this.uploadcounter) {
          this.uploadFile(this.uploadfilearray[this.uploadcounter], filename, num_chunks, this.uploadcounter + 1, file_type, product_type, obj);
          this.feed_post_uploading_file.next(this.current_uploading_file);
        } else {
          file_type = file_type.split('/');
          const ftype = (file_type[0] == 'image') ? 'image' : (file_type[0] == 'video') ? 'video' : (file_type[0] == 'application') ? 'document' : '';
          const media = {
            'media_type': ftype,
            'media_url': data.data.fileurl,
            'media_thumbnail': data.data.absolute_path,
            'media_height': '1233',
            'media_width': '3222',
            'media_resolution': '2222',
            'media_name': 'file_name',
            'media_time_duration': 0
          };
          const temp = { total: this.total_files, uploaded: this.current_uploading_file, media: media };

          setTimeout(() => {
            if (ftype == 'video') {
              this.uploadVideoThumbnail(obj, temp);
            } else if (ftype == 'document') {
              this.uploadPdfThumbnail(obj, temp);
            } else {
              this.fileUploadProcess.next(temp);
            }
          }, 300);

        }

      }, () => {
        this.fileUploadaing_failed.next(product_type);
        this.dss.profileImageApi = true;
        return;
      }));
    }
  }

  /**
   * data URI to Blob
   */
  dataURItoBlob(dataURI): Blob {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/jpg'
    });

  }

  /**
   * generate Thumbnail
   */
  public generateThumbnail(videoFile: Blob): Promise<string> {
    const video: HTMLVideoElement = this.document.createElement('video');
    const canvas: HTMLCanvasElement = this.document.createElement('canvas');
    const context: CanvasRenderingContext2D = canvas.getContext('2d');
    return new Promise<string>((resolve, reject) => {
      canvas.addEventListener('error', reject);
      video.addEventListener('error', reject);
      video.addEventListener('canplay', () => {
        if (video.videoWidth === 0 && video.videoHeight === 0) {
          reject();
        }
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        const time = Math.floor((video.duration * 1000));
        const x = { data: canvas.toDataURL(), duration: time };
        resolve(JSON.stringify(x));
      });
      if (videoFile.type) {
        video.setAttribute('type', videoFile.type);
      }
      video.preload = 'auto';
      video.src = window.URL.createObjectURL(videoFile);
      video.load();
      // setTimeout(() => {

      // }, 500);
    }).catch(() => 'Failed to generate thumbnail');
  }

  /**
   * generate Pdf Thumbnail
   */
  public generatePdfThumbnail(pdfFile: Blob): Promise<string> {

    return new Promise<string>((resolve, reject) => {
      const url = window.URL.createObjectURL(pdfFile);
      pdfjsLib.getDocument(url)
        .promise.then(function (pdf) {
          return pdf.getPage(1);
        }).then(async function (page) {
          // Set scale (zoom) level
          const scale = 1.5;
          // Get viewport (dimensions)
          const viewport = (await page).getViewport({ scale: scale });

          // Get canvas#the-canvas

          const canvas = document.createElement('canvas');
          canvas.id = 'mycanvas';
          canvas.style.display = 'none';

          document.body.appendChild(canvas);

          // var canvas = <HTMLCanvasElement> document.getElementById("mycanvas");

          // Fetch canvas' 2d context
          const context = canvas.getContext('2d');
          if (viewport.height === 0 && viewport.width === 0) {
            reject();
          }
          // Set dimensions to Canvas
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // Prepare object needed by render method
          const renderContext = {
            canvasContext: context,
            viewport: viewport
          };
          // Render PDF page
          (await
            page).render(renderContext);

          setTimeout(() => {
            const dataURL = canvas.toDataURL();
            const x = { data: dataURL, duration: 0 };
            resolve(JSON.stringify(x));
          }, 1000);
        });

    }).catch((e) => {
      console.error('Failed to Generate thumbnail:', e);
      console.trace(); // Prints a stack trace
      return `Failed to Generate thumbnail: ${e.message}`;
    });
  }

  /**
   * upload Pdf Thumbnail
   */
  uploadPdfThumbnail(obj, uploadedData): void {
    this.generatePdfThumbnail(obj).then(data => {
      data = JSON.parse(data);
      this.current_uploading_file = uploadedData.uploaded;
      this.total_files = uploadedData.total;
      this.uploadcounter = 0;
      this.uploadfilearray = [];
      const file = obj;
      const file_type = 'image';
      const blob = this.dataURItoBlob(data['data']);
      let BYTES_PER_CHUNK = 1000024; // **1MB chunk sizes.
      const SIZE = blob.size;
      if (SIZE > 1000024) {
        BYTES_PER_CHUNK = 1000024;
      } else if (SIZE > 100024) {
        BYTES_PER_CHUNK = 100024;
      } else if (SIZE > 10024) {
        BYTES_PER_CHUNK = 10024;
      } else {
        BYTES_PER_CHUNK = 1024;
      }

      const remaining_bites = SIZE % BYTES_PER_CHUNK;
      let start = 0;
      let end = BYTES_PER_CHUNK;
      const d = new Date();
      const n = d.getTime();
      let fileName;

      const count_x = Math.floor(SIZE / BYTES_PER_CHUNK);
      let x = 0;
      while (x < count_x) {
        const chunk = blob.slice(start, end);
        this.uploadfilearray[this.uploadcounter] = chunk;
        this.uploadcounter = this.uploadcounter + 1;
        start = end;
        end = start + BYTES_PER_CHUNK;
        x++;
      }
      if (remaining_bites > 0) {
        const chunk = blob.slice(start, end);
        this.uploadfilearray[this.uploadcounter] = chunk;
        this.uploadcounter = this.uploadcounter + 1;
        start = end;
        end = remaining_bites;
      }
      const num_chunks = this.uploadcounter; // total number of chunks
      this.uploadcounter = 0;
      fileName = n + file.name;

      fileName = fileName.replace('.mp4', '.png');
      fileName = fileName.replace('.pdf', '.png');
      this.uploadVideoThumbnailFile(this.uploadfilearray[this.uploadcounter], fileName, num_chunks, this.uploadcounter + 1, file_type, '1', obj, uploadedData, data['duration']);

    });
  }

  /**
   * upload Video Thumbnail
   */
  uploadVideoThumbnail(obj, uploadedData): void {
    this.generateThumbnail(obj).then(data => {
      data = JSON.parse(data);
      this.current_uploading_file = uploadedData.uploaded;
      this.total_files = uploadedData.total;
      this.uploadcounter = 0;
      this.uploadfilearray = [];
      const file = obj;
      const file_type = 'image';
      const blob = this.dataURItoBlob(data['data']);
      let BYTES_PER_CHUNK = 1000024; // **1MB chunk sizes.
      const SIZE = blob.size;
      if (SIZE > 1000024) {
        BYTES_PER_CHUNK = 1000024;
      } else if (SIZE > 100024) {
        BYTES_PER_CHUNK = 100024;
      } else if (SIZE > 10024) {
        BYTES_PER_CHUNK = 10024;
      } else {
        BYTES_PER_CHUNK = 1024;
      }

      const remaining_bites = SIZE % BYTES_PER_CHUNK;
      let start = 0;
      let end = BYTES_PER_CHUNK;
      const d = new Date();
      const n = d.getTime();
      let fileName;

      const count_x = Math.floor(SIZE / BYTES_PER_CHUNK);
      let x = 0;
      while (x < count_x) {
        const chunk = blob.slice(start, end);
        this.uploadfilearray[this.uploadcounter] = chunk;
        this.uploadcounter = this.uploadcounter + 1;
        start = end;
        end = start + BYTES_PER_CHUNK;
        x++;
      }
      if (remaining_bites > 0) {
        const chunk = blob.slice(start, end);
        this.uploadfilearray[this.uploadcounter] = chunk;
        this.uploadcounter = this.uploadcounter + 1;
        start = end;
        end = remaining_bites;
      }
      const num_chunks = this.uploadcounter; // total number of chunks
      this.uploadcounter = 0;
      fileName = n + file.name;

      fileName = fileName.replace('.mp4', '.png');
      fileName = fileName.replace('.pdf', '.png');
      fileName = fileName.replace('.MOV', '.png');
      this.uploadVideoThumbnailFile(this.uploadfilearray[this.uploadcounter], fileName, num_chunks, this.uploadcounter + 1, file_type, '1', obj, uploadedData, data['duration']);
    });
  }

  /**
   * upload Video Thumbnail File
   */
  uploadVideoThumbnailFile(blobFile, filename, num_chunks, num, file_type, product_type, obj, uploadedData, duration): void {
    if (this.uploadfilearray.length > this.uploadcounter) {
      this.subscriptions.add(this.onboardingService.newUploadInChunk(blobFile, filename, num_chunks, num, file_type, product_type).subscribe(data => {
        // const videoUploadRes = data;
        this.uploadcounter = this.uploadcounter + 1;
        if (this.uploadfilearray.length > this.uploadcounter) {
          this.uploadVideoThumbnailFile(this.uploadfilearray[this.uploadcounter], filename, num_chunks, this.uploadcounter + 1, file_type, product_type, obj, uploadedData, duration);
        } else {
          uploadedData.media.media_thumbnail = data.data.fileurl;
          uploadedData.media.media_time_duration = duration;
          const temp = { total: this.total_files, uploaded: this.current_uploading_file, media: uploadedData.media };

          this.fileUploadProcess.next(temp);
        }

      }, () => {
        this.fileUploadaing_failed.next(product_type);

      }));
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
